import dialogErrorTemplate from './dialog-error/dialog-error.html';
import studentsErrorTemplate from './dialog-error/dialog-error-students.html';
import newErrorTemplate from './dialog-error/dialog-error-new.html';
import detailsErrorTemplate from './dialog-error/dialog-error-v2.html';

/**
 * @ngInject
 *
 * @param {$mdThemingProvider} $mdThemingProvider
 * @param {$mdDateLocaleProvider} $mdDateLocaleProvider
 * @param {moment} moment
 *
 */

export default ($mdThemingProvider, $mdDateLocaleProvider, $mdDialogProvider, moment, TourConfigProvider, treeConfig) => {
  $mdThemingProvider.theme('default')
    .primaryPalette('indigo', {
      'hue-2': '900'
    })
    .accentPalette('pink');
  $mdDateLocaleProvider.months = [
    'styczeń',
    'luty',
    'marzec',
    'kwiecień',
    'maj',
    'czerwiec',
    'lipiec',
    'sierpień',
    'wrzesień',
    'październik',
    'listopad',
    'grudzień'
  ];

  $mdDateLocaleProvider.shortMonths = [
    'sty',
    'lut',
    'mar',
    'kwi',
    'maj',
    'cze',
    'lip',
    'sie',
    'wrz',
    'paź',
    'lis',
    'gru'
  ];

  $mdDateLocaleProvider.days = [
    'niedziela',
    'poniedziałek',
    'wtorek',
    'środa',
    'czwartek',
    'piątek',
    'sobota'
  ];

  $mdDateLocaleProvider.shortDays = [
    'Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'
  ];
  $mdDateLocaleProvider.firstDayOfWeek = 1;
  $mdDateLocaleProvider.msgCalendar = 'Kalendarz';
  $mdDateLocaleProvider.msgOpenCalendar = 'Otwórz kalendarz';

  $mdDateLocaleProvider.parseDate = dateString => {
    const m = moment(dateString, 'L', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };

  $mdDateLocaleProvider.formatDate = date => {
    const m = moment(date);
    return m.isValid() ? m.format('L') : '';
  };

  $mdDateLocaleProvider.weekNumberFormatter = weekNumber => {
    return 'Tydzień ' + weekNumber;
  };

  $mdDialogProvider.addPreset('extendError', {
    options: () => {
      return {
        template: dialogErrorTemplate,
        controllerAs: 'ctrl',
        controller: 'DialogErrorController',
        bindToController: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        multiple: true
      };
    }
  });

  $mdDialogProvider.addPreset('studentsError', {
    options: () => {
      return {
        template: studentsErrorTemplate,
        controllerAs: 'ctrl',
        controller: 'DialogErrorController',
        bindToController: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        multiple: true
      };
    }
  });

  $mdDialogProvider.addPreset('newError', {
    options: () => {
      return {
        template: newErrorTemplate,
        controllerAs: 'ctrl',
        controller: 'DialogErrorController',
        bindToController: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        multiple: true
      };
    }
  });

  $mdDialogProvider.addPreset('detailsError', {
    options: () => {
      return {
        template: detailsErrorTemplate,
        controllerAs: 'ctrl',
        controller: 'DetailsErrorController',
        bindToController: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        multiple: true
      };
    }
  });

  TourConfigProvider.set('templateUrl', 'tour-step-template');

  treeConfig.emptyTreeClass += ' scr-empty-tree';
  treeConfig.treeClass += ' scr-tree';
};
